import {Clone, GetEntries} from "js-vextensions";
import {Button, Column, Row, Select} from "react-vcomponents";
import {BaseComponentPlus} from "react-vextensions";
import {GetUpdates, Observer, RunInAction, RunInAction_Set} from "web-vcore";
import {Session} from "../../../Server/DB/sessions/@Session.js";
import {store} from "../../../Store/index.js";
import {SessionUITab} from "../../../Store/main/timeline.js";
import {SessionUI_DetailsUI} from "./SessionUI/DetailsUI.js";
import {SessionUI_EventsUI} from "./SessionUI/EventsUI.js";
import {SessionUI_GeneralUI} from "./SessionUI/GeneralUI.js";
import {UpdateSession} from "../../../Server/Commands/SessionCommands.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {GetSelectedSessionExternals} from "../../../Store/main/timeline/SessionDerivativeData.js";
import {GetSessionPeriodStr} from "../Sessions.js";

export type SessionChangerFunc = (session: Session)=>any;
export type SessionUI_SharedProps = {session: Session, ChangeSession: (changerFunc: SessionChangerFunc)=>void};

export const SessionUI = observer_mgl((props: {session: Session})=>{
	const {session} = props;
	const uiState = store.main.timeline.sessions;
	//if (GetSelectedSessionExternals()?.sessionID != uiState.selectedSession) return; // if derivative-data hasn't loaded yet, wait

	const ChangeSession = (changerFunc: SessionChangerFunc)=>{
		const newSession = Clone(session);
		changerFunc(newSession);
		new UpdateSession({id: session.id, updates: GetUpdates(session, newSession, true)}).RunOnServer();
	};

	const sharedProps = {session, ChangeSession};
	return (
		<Column style={{height: "100%"}}>
			<Row>
				<Button text="Back" onClick={()=>{
					RunInAction("SessionUI.Back.onClick", ()=>uiState.selectedSession = null);
				}}/>
				<Select ml={5} displayType="button bar" options={
					GetEntries(SessionUITab, "ui")
						.VAct(a=>a.find(b=>b.value == SessionUITab.events)!.name = `Events (${session.events.length})`)
				} value={uiState.tab} onChange={val=>RunInAction_Set(()=>uiState.tab = val)}/>
				<Row pr={315} style={{flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18}}>{GetSessionPeriodStr(session)}</Row>
			</Row>
			{uiState.tab == "general" && <SessionUI_GeneralUI {...sharedProps}/>}
			{uiState.tab == "details" && <SessionUI_DetailsUI {...sharedProps}/>}
			{uiState.tab == "events" && <SessionUI_EventsUI {...sharedProps}/>}
		</Column>
	);
});

/*function SleepStageTest() {
	// get only first hour of data, for now
	const samples_left_simple = new Float32Array(sessionProcessor_orig.eegProcessor.samples_left); //.slice(0, Muse_eegSamplesPerSecond_raw * 60 * 60));
	const samples_right_simple = new Float32Array(sessionProcessor_orig.eegProcessor.samples_right); //.slice(0, Muse_eegSamplesPerSecond_raw * 60 * 60));
	const samples_left_ear_simple = new Float32Array(sessionProcessor_orig.eegProcessor.samples_left_ear); //.slice(0, Muse_eegSamplesPerSecond_raw * 60 * 60));
	const samples_right_ear_simple = new Float32Array(sessionProcessor_orig.eegProcessor.samples_right_ear); //.slice(0, Muse_eegSamplesPerSecond_raw * 60 * 60));

	const blockSleepStages = CalculateSleepStagesForEEGSamples(samples_left_simple, samples_right_simple, samples_left_ear_simple, samples_right_ear_simple);
	console.log("BlockSleepStages:", blockSleepStages);
	// 3: awake, 2: rem, 1: light, 0: deep (from: extractSleepStagesUserSession)
}*/